import { useLocation, useNavigate } from "react-router-dom";
import { Undo2 } from "lucide-react";
import { loadStudySession } from "@/lib/studySession";

/**
 * Floating "resume study" pill. Appears on every page except /study
 * whenever a study session is mid-deck, so users can wander off to
 * investigate a kanji card (or anything else) and always find their
 * way back to the exact card they left.
 */
export default function ReturnToStudy() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (pathname === "/study") return null;
  const s = loadStudySession();
  if (!s?.items?.length || s.idx >= s.items.length) return null;
  const current = s.items[s.idx];
  return (
    <button
      type="button"
      data-testid="return-to-study"
      onClick={() => navigate("/study")}
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2.5 bg-sumi text-washi pl-3.5 pr-5 py-2.5 rounded-full shadow-lg hover:bg-shu transition-colors"
    >
      <Undo2 size={14} />
      <span className="font-serif text-xl leading-none" aria-hidden="true">
        {current?.kanji}
      </span>
      <span className="font-sans text-[10px] uppercase tracking-[0.25em] whitespace-nowrap">
        resume study · {s.idx + 1}/{s.items.length}
      </span>
    </button>
  );
}
